import { useEffect } from 'react';

type JsonLdProps = {
  id?: string;
  data: Record<string, unknown>;
};

export default function JsonLd({ id = 'jsonld-primary', data }: JsonLdProps) {
  useEffect(() => {
    let script = document.head.querySelector<HTMLScriptElement>(`script#${CSS.escape(id)}`);
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = id;
      document.head.appendChild(script);
    }
    script.text = JSON.stringify(data);
    return () => {
      // optional cleanup: keep last useful jsonld for share/refresh
    };
  }, [id, data]);

  return null;
}

